module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/0a802c4759154178410d9806072b1e8e.svg";